import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from '../../tools/components/AgentExtras.module.css';

export const RulesHubPage: React.FC = () => {
  const { t } = useTranslation('agentRules');

  return (
    <div className={styles.page}>
      <p className={styles.rulesIntro}>{t('intro')}</p>
      <div className={styles.ruleGrid}>
        <Link className={styles.ruleCard} to="/ai/config">
          <h3>{t('alwaysOnTitle')}</h3>
          <p>{t('alwaysOnText')}</p>
          <span>{t('alwaysOnAction')}</span>
        </Link>
        <Link className={styles.ruleCard} to="/ai/config">
          <h3>{t('toolInstructionsTitle')}</h3>
          <p>{t('toolInstructionsText')}</p>
          <span>{t('toolInstructionsAction')}</span>
        </Link>
        <Link className={styles.ruleCard} to="/automations">
          <h3>{t('inboundTitle')}</h3>
          <p>{t('inboundText')}</p>
          <span>{t('inboundAction')}</span>
        </Link>
        <Link className={styles.ruleCard} to="/automations?tab=quiet">
          <h3>{t('quietTitle')}</h3>
          <p>{t('quietText')}</p>
          <span>{t('quietAction')}</span>
        </Link>
      </div>
    </div>
  );
};

export default RulesHubPage;
